import { render, staticRenderFns } from "./OMAlarmsInfoList.vue?vue&type=template&id=68ccf888&scoped=true&"
import script from "./OMAlarmsInfoList.vue?vue&type=script&lang=js&"
export * from "./OMAlarmsInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ccf888",
  null
  
)

export default component.exports